import * as React from "react";

import { useParams } from "react-router-dom";

import Accordion from "react-bootstrap/Accordion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

import Paper from "../../Components/Paper";

import axiosInstance from "../../Api/Axios";
import { useLoader } from "../../Context/LoaderContext";
import { useToast } from "../../Context/ToastContext";

import { addSeparateur } from "../../Functions/separateur_chiffre";

import { statusFinancing } from "../../Functions/satus_financing_request";
import { wrapStatusFinancing } from "../../Functions/wrap_satus_financing_request";

import "./DetailsFinancingRequest.scss";

const DetailsFinancingRequest = () => {
  const [dataRecap, setDataRecap] = React.useState([]);

  const { setIsLoading } = useLoader();
  const { addToast } = useToast();

  const { id } = useParams();

  React.useEffect(() => {
    setIsLoading(true);

    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation/${id}`)
      .then(async (response) => {
        setIsLoading(false);
        const data = response.data.data || {};
        setDataRecap(data);
      })
      .catch((error) => {
        setIsLoading(false);
        addToast({
          variant: "danger",
          message: error.response.data.data.message,
        });
      });
  }, [addToast, id, setIsLoading]);

  return (
    <>
      <div className="back-home">
        <Link to="/list-financing-request" className="link-back">
          <RiArrowLeftLine />
        </Link>
      </div>
      <h1>Informations Financières</h1>
      <p>
        Revoyez toutes les informations fournies dans ce formulaire pour vous
        assurer de leur exactitude et de leur exhaustivité.
      </p>

      <Paper>
        <Row className="mb-64">
          <Col md={12} className="mb-24">
            <div className="box-folder-number">
              <div className="title-details-financement mb-4">
                Numéro de Dossier
              </div>
              <div className="caption-details-financement">
                {dataRecap?.reference}
              </div>
            </div>
          </Col>
          <Col md={12}>
            <div className={wrapStatusFinancing(dataRecap?.status)}>
              <div className="title-details-financement">
                {/* Votre demande est actuellement en cours de traitement. */}
                {statusFinancing(dataRecap?.status, dataRecap?.status_text)}
              </div>
              <div
                className="content-details-financement bold"
                dangerouslySetInnerHTML={{
                  __html: dataRecap?.status_description,
                }}
              />
              {/* <div className="sub-title-details-financement">
              Merci de votre patience.
            </div> */}
            </div>
          </Col>
        </Row>
        <div className="step-simulateur">
          <div className="step-financing-request custom-accordion mb-16">
            <Accordion defaultActiveKey="0" alwaysOpen>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Détails du Projet de Leasing
                </Accordion.Header>
                <Accordion.Body>
                  <table className="table custom-table">
                    <tbody>
                      <tr>
                        <td>Montant</td>
                        <td>
                          {addSeparateur(dataRecap?.simulation?.amount) || "-"}{" "}
                          TND
                        </td>
                      </tr>
                      <tr>
                        <td>Autofinancement</td>
                        <td>
                          {addSeparateur(
                            dataRecap?.simulation?.self_financing
                          ) || "-"}{" "}
                          TND
                        </td>
                      </tr>
                      <tr>
                        <td>Durée</td>
                        <td className="orange">
                          {dataRecap?.simulation?.duration || "-"} mois
                        </td>
                      </tr>

                      <tr>
                        <td>Type de bien à financer</td>
                        <td className="text-capitalize">
                          {dataRecap?.simulation?.product_name || "-"}
                        </td>
                      </tr>

                      <tr>
                        <td>Description</td>
                        <td>{dataRecap?.simulation?.description || "-"}</td>
                      </tr>

                      <tr>
                        <td colSpan={2} className="last-child-table">
                          <div className="titlte-montant">
                            Montant du loyer par mois
                          </div>
                          <div className="value-montant">
                            {addSeparateur(
                              dataRecap?.simulation?.result_amount
                            ) || "-"}
                            TND
                          </div>
                          <p>Le taux appliqué au niveau du site est à titre indicatif</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  Informations sur le Demandeur
                </Accordion.Header>
                <Accordion.Body>
                  <table className="table custom-table">
                    <tbody>
                      {dataRecap?.client_name && (
                        <tr>
                          <td>Nom</td>
                          <td>{dataRecap.client_name || "-"}</td>
                        </tr>
                      )}
                      {dataRecap?.tax_id && (
                        <tr>
                          <td>Matricule fiscal</td>
                          <td>{dataRecap.tax_id || "-"}</td>
                        </tr>
                      )}
                      {dataRecap?.created_at && (
                        <tr>
                          <td>Date de création</td>
                          <td>{dataRecap.created_at || "-"}</td>
                        </tr>
                      )}
                      {dataRecap?.request_type && (
                        <tr>
                          <td>Secteur d'Activité</td>
                          <td>{dataRecap.activity_sector || "-"}</td>
                        </tr>
                      )}
                      {dataRecap?.email && (
                        <tr>
                          <td>Email</td>
                          <td>{dataRecap.email || "-"}</td>
                        </tr>
                      )}
                      {dataRecap?.phone && (
                        <tr>
                          <td>Téléphone</td>
                          <td>{dataRecap.phone || "-"}</td>
                        </tr>
                      )}
                      {dataRecap.fax && (
                        <tr>
                          <td>Fax</td>
                          <td>{dataRecap.fax || "-"}</td>
                        </tr>
                      )}

                      <tr>
                        <td>Adresse</td>
                        <td>
                          {(dataRecap.address && dataRecap.address) || "-"}
                          <br />
                          {(dataRecap?.postal_code && dataRecap.postal_code) +
                            " - " +
                            dataRecap.city}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Documents Fournis</Accordion.Header>
                <Accordion.Body>
                  <ul className="list-accordion">
                    {dataRecap?.documents?.map((doc) => {
                      return <li key={doc.id}>{doc.title}</li>;
                    })}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default DetailsFinancingRequest;
